module.exports = __webpack_public_path__ + "img/addImgWhite.84dad0db.svg";